import { exportDeliveryRecordExcel, exportOrderExcel, OrderId } from "..";

export const exportData = (data, columns, type = 'order') => {
    const exportData = data.map(item => {
        const row = {};
        columns.forEach(colKey => {
            if (colKey === "id" && type === 'order') row[colKey] = OrderId(item[colKey]);
            else if (colKey === "action" || colKey === 'check' || colKey === 'image' || colKey === 'furnitureimage') return;
            else row[colKey] = item[colKey];
        });
        return row;
    });

    console.log("依據當前欄位選擇 & 篩選條件輸出的資料：", exportData);
    if (type === 'order') exportOrderExcel(exportData, columns);
    else exportDeliveryRecordExcel(exportData, columns);
    alert(`目前匯出 ${exportData.length} 筆資料。`);
};
